<template>
    <el-dialog title="水温设置" :model-value="modelValue" width="600px" @opened="dialogOpened" @close="dialogClose">
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="150px" label-suffix="：">
            <el-form-item label="入水温度" prop="enter_temp">
                <el-input-number v-model="formData.enter_temp" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="入水温度补偿" prop="enter_temp_adjust">
                <el-input-number v-model="formData.enter_temp_adjust" :min="-100" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="入水过高温度" prop="enter_alarm_temp_high">
                <el-input-number v-model="formData.enter_alarm_temp_high" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="入水过低温度" prop="enter_alarm_temp_low">
                <el-input-number v-model="formData.enter_alarm_temp_low" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="出水温度" prop="differ_temp">
                <el-input-number v-model="formData.differ_temp" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="出水温度补偿" prop="out_temp_adjust">
                <el-input-number v-model="formData.out_temp_adjust" :min="-100" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="出水过高温度" prop="out_alarm_temp_high">
                <el-input-number v-model="formData.out_alarm_temp_high" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
            <el-form-item label="出水过低温度" prop="out_alarm_temp_low">
                <el-input-number v-model="formData.out_alarm_temp_low" :min="0" :max="100" :step="0.1" :precision="1">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogClose">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { batchPatchValveParams } from '@/api/heating/devicePoint/devicePoint.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    detailData: {
        type: Object,
        required: true
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 弹窗打开
function dialogOpened() {
    Object.keys(props.detailData).forEach((key) => {
        if (formData.value.hasOwnProperty(key)) {
            formData.value[key] = props.detailData[key]
        }
    })
    console.log(formData.value)
}

// 表单源
const formData = ref({
    enter_temp: 0,
    enter_temp_adjust: 0,
    enter_alarm_temp_high: 0,
    enter_alarm_temp_low: 0,
    differ_temp: 0,
    out_temp_adjust: 0,
    out_alarm_temp_high: 0,
    out_alarm_temp_low: 0
})

// 验证规则
const formRules = ref({})
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const dialogClose = () => {
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

function handleConfirm() {
    const data = {
        type: 3,
        id_list: props.detailData.id_list,
        ...formData.value
    }
    // 去除data中的空值，防止误将数据设置为空
    Object.keys(data).forEach((key) => {
        if (data[key] === '' || data[key] === undefined) {
            delete data[key]
        }
    })
    console.log(data)
    batchPatchValveParams(data).then((res) => {
        emits('updateForm')
        ElMessage.success('设置成功！')
        submitLoading.value = false
        dialogClose()
    })
}
</script>

<style scoped></style>
